import { render, staticRenderFns } from "./ProUserSign.vue?vue&type=template&id=3b10800a&scoped=true&"
import script from "./ProUserSign.vue?vue&type=script&lang=js&"
export * from "./ProUserSign.vue?vue&type=script&lang=js&"
import style0 from "./ProUserSign.vue?vue&type=style&index=0&id=3b10800a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b10800a",
  null
  
)

export default component.exports